import { useNavigate } from "react-router-dom";
import { useAppContext } from "src/context/AppContext";
import { ProjectsTableRow } from "../types";
import { useCallback } from "react";

export const useProjectNavigation = () => {
  const navigate = useNavigate();
  const { context, setContext } = useAppContext();
  const goToPremisesByProject = useCallback(
    (chosenRow: ProjectsTableRow) => {
      setContext({
        project: chosenRow.projectRaw.project,
        requestingCompany: chosenRow.requestingCompany,
      });
      navigate(`/premises/${chosenRow.id}`);
    },
    [context, navigate, setContext]
  );
  return { goToPremisesByProject };
};
